/**
 * Created by Alex Aguilar on 7/11/2016.
 */
(function() {
    'use strict';

    angular
        .module('completeAir')
        .directive('loadBoardingGate', ['boardingGateService', 'messageService', loadBoardingGate]);

    function loadBoardingGate(boardingGateService, messageService) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;



        function linkFunc(scope, element, attributes){
            var airportId = attributes.airportId,
                index = attributes.index;

            boardingGateService.getBoardingGatesByAirport(airportId)
                .then(function(response){
                    scope.boardingGates[index] = response.data._embedded.boardinggates;
                }).catch(function(){
                    messageService.findAllError();
                })
        }
    }

})();
